import { render, staticRenderFns } from "./detailHandover.vue?vue&type=template&id=5e59a796"
import script from "./detailHandover.vue?vue&type=script&lang=js"
export * from "./detailHandover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports